import styled from '@emotion/styled';
import { SwapHoriz as SwapHorizIcon } from '@mui/icons-material';
import { memo, useState } from 'react';
import { Button } from '~/modules/Elements/AKUI/Button';
import { MenuButton } from '~/modules/Elements/AKUI/Menu/MenuButton';
import Modal from '~/modules/Elements/Modal';
import RemoteMicClient from '~/modules/RemoteMic/Network/Client';
import PlayerChangeModal from '~/routes/RemoteMic/Components/PlayerChangeModal';
import PlayerNumberCircle from '~/routes/RemoteMic/Components/PlayerNumberCircle';
import useServerEvent from '~/routes/RemoteMic/hooks/useServerEvent';

interface Props {
  playerNumber: 0 | 1 | 2 | 3 | null;
  defaultOpen?: boolean;
}

export default memo(function PlayerChange({ playerNumber, defaultOpen = false }: Props) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const closeModal = () => setIsOpen(false);

  const joined = playerNumber !== null;

  useServerEvent(
    (message) => {
      if (message.t === 'song-selection-player-settings') {
        if (!joined) {
          setIsOpen(true);
        }
      }
    },
    [joined, setIsOpen],
  );

  return (
    <>
      <PlayerButton size="small" onClick={() => setIsOpen(true)} data-test="change-player" data-joined={joined}>
        {!joined ? (
          'Join game'
        ) : (
          <>
            <PlayerNumberCircle number={playerNumber} /> Change
          </>
        )}{' '}
        <Button.Icon Icon={SwapHorizIcon} />
      </PlayerButton>
      <Modal onClose={closeModal} open={isOpen}>
        {isOpen && (
          <PlayerChangeModal
            header="Your color"
            id={RemoteMicClient.getClientId()!}
            playerNumber={playerNumber}
            onModalClose={closeModal}
          />
        )}
      </Modal>
    </>
  );
});

const PlayerButton = styled(MenuButton)`
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 3;
  width: auto !important;
  min-width: 128px;
  min-height: 44px !important;
  padding: 0 12px !important;
  border-radius: 999px !important;
  background: color-mix(in srgb, var(--walky-canvas) 76%, transparent) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.28) !important;
  backdrop-filter: blur(10px);

  &[data-joined='false'] {
    background: linear-gradient(135deg, var(--walky-orange), #ff7a1a) !important;
    border-color: rgba(244, 90, 10, 0.4) !important;
  }
`;
